import CompFeatures from '../components/Features/'
  
  export default function App(props) {
    return (
      <CompFeatures />
    )
  }
